module.exports = __webpack_public_path__ + "static/media/top-friends-video.bb9fef19.mp4";